//Acciones de Sesión
export const OPEN_SESSION = "OPEN_SESSION";
export const CLOSE_SESSION = "CLOSE_SESSION";